import AboutUs from "@/modules/frontend/pages/About_Us";
import OurServices from "@/modules/frontend/pages/Our_Services";
import Index from "@/modules/frontend/pages/Home";

import ForgotPasswordForm from "@/modules/frontend/pages/Forgot_Password";
import Login from "@/modules/frontend/pages/Login";
import ResetpasswordForm from "@/modules/frontend/pages/Reset_Password";

import ContactUs from "@/modules/frontend/pages/Contact_Us";
// import LandingPage from "../V2/LandingPage";
import LandingPage from "@/modules/frontend/pages/Landing_Page";
import NoLandingPage from "@/modules/frontend/pages/Landing_Page/not_found_page";
import TermsAndConditions from "@/modules/frontend/pages/Terms_And_Conditions";
import PrivacyPolicy from "@/modules/frontend/pages/Privacy_Policy";
import SupplierInquiry from "@/modules/frontend/pages/Inquiry_Supplier";
import LogisticInquiry from "@/modules/frontend/pages/Inquiry_Logistic";
import BecomeSupplier from "@/modules/frontend/pages/Become_Supplier";
import JoinLogistic from "@/modules/frontend/pages/Join_Logistic";
import SearchDetail from "@/modules/frontend/pages/Search_Detail";
import ViewAllInquiries from "@/modules/frontend/pages/View_All_Inquiries";
import Register from "@/modules/frontend/pages/Register";
import GlobalTradeNetwork from "@/modules/frontend/pages/Benefits/Global_Trade_Network";
import DigitalPromotion from "@/modules/frontend/pages/Benefits/Digital_Promotion";
import FinancialProtection from "@/modules/frontend/pages/Benefits/Financial_Protection";
import CustomerSupport from "@/modules/frontend/pages/Benefits/Customer_Support";
import QualityBusinessLeads from "@/modules/frontend/pages/Benefits/Quality_Business_Leads";
import EventGallery from "@/modules/frontend/pages/Event_Gallery";
import OurProducts from "@/modules/frontend/pages/Our_Products";
import BlogList from "@/modules/frontend/pages/Blog_Listing";
import BlogDetail from "@/modules/frontend/pages/Blog_Detail";
import MarketPlace from "@/modules/frontend/pages/Market_Place";
import ProductCatalogue from "@/modules/frontend/pages/Market_Place/productCatalogue";
import MarketDetail from "@/modules/frontend/pages/Market_Place/marketDetail";
import OurPartnersDetail from "@/modules/frontend/pages/Our_Partners";
import SearchSuppliers from "@/modules/frontend/pages/Market_Place/searchSuppliers";


import { publicRoutePaths } from "./public.routes.config";


const publicRoutes = {
    REGISTRATION: {
        ...publicRoutePaths.REGISTRATION,
        element: <Register />,
    },
    REGISTRATION_V2: {
        ...publicRoutePaths.REGISTRATION_V2,
        element: <Register />,
    },
    LOGIN: {
        ...publicRoutePaths.LOGIN,
        element: <Login />
    },
    FORGOT_PSWD: {
        ...publicRoutePaths.FORGOT_PSWD,
        element: <ForgotPasswordForm />,

    },
    RESET_PSWD: {
        ...publicRoutePaths.RESET_PSWD,
        element: <ResetpasswordForm />
    },
    TERMS: {
        ...publicRoutePaths.TERMS,
        element: <TermsAndConditions />
    },
    SUPPLIER_TERMS: {
        ...publicRoutePaths.SUPPLIER_TERMS,
        element: <TermsAndConditions />
    },
    BUYER_TERMS: {
        ...publicRoutePaths.BUYER_TERMS,
        element: <TermsAndConditions />
    },
    LOGISTIC_TERMS: {
        ...publicRoutePaths.LOGISTIC_TERMS,
        element: <TermsAndConditions />
    },
    BUYER_SUPPLIER_TERMS: {
        ...publicRoutePaths.BUYER_SUPPLIER_TERMS,
        element: <TermsAndConditions />
    },
    HOME: {
        ...publicRoutePaths.HOME,
        element: <Index />
    },
    ABOUT_US: {
        ...publicRoutePaths.ABOUT_US,
        element: <AboutUs />
    },
    OUR_SERVICES: {
        ...publicRoutePaths.OUR_SERVICES,
        element: <OurServices />
    },
    GLOBAL_TRADE_NETWORK: {
        ...publicRoutePaths.GLOBAL_TRADE_NETWORK,
        element: <GlobalTradeNetwork />
    },
    DIGITAL_PROMOTION: {
        ...publicRoutePaths.DIGITAL_PROMOTION,
        element: <DigitalPromotion />
    },
    FINANCIAL_PROTECTION: {
        ...publicRoutePaths.FINANCIAL_PROTECTION,
        element: <FinancialProtection />
    },
    CUSTOMER_SUPPORT: {
        ...publicRoutePaths.CUSTOMER_SUPPORT,
        element: <CustomerSupport />
    },
    BUSINESS_LEADS: {
        ...publicRoutePaths.BUSINESS_LEADS,
        element: <QualityBusinessLeads />
    },
    EVENT_HIGHLIGHTS: {
        ...publicRoutePaths.EVENT_HIGHLIGHTS,
        element: <EventGallery />
    },
    SUPPLIER_INQUIRY: {
        ...publicRoutePaths.SUPPLIER_INQUIRY,
        element: <SupplierInquiry />
    },
    LOGISTIC_INQUIRY: {
        ...publicRoutePaths.LOGISTIC_INQUIRY,
        element: <LogisticInquiry />
    },
    CONTACT_US: {
        ...publicRoutePaths.CONTACT_US,
        element: <ContactUs />
    },
    LANDING_PAGE: {
        ...publicRoutePaths.LANDING_PAGE,
        element: <LandingPage masking={false} />
    },
    LANDING_PAGE_NOT_FOUND: {
        ...publicRoutePaths.LANDING_PAGE_NOT_FOUND,
        element: <NoLandingPage />
    },
    COMPANY_PAGE_NOT_FOUND: {
        ...publicRoutePaths.COMPANY_PAGE_NOT_FOUND,
        element: <NoLandingPage />
    },
    BECOME_SUPPLIER: {
        ...publicRoutePaths.BECOME_SUPPLIER,
        element: <BecomeSupplier />
    },
    JOIN_LOGISTIC: {
        ...publicRoutePaths.JOIN_LOGISTIC,
        element: <JoinLogistic />
    },
    SEARCH_DETAIL: {
        ...publicRoutePaths.SEARCH_DETAIL,
        element: <SearchDetail />
    },
    VIEW_ALL_INQUIRIES: {
        ...publicRoutePaths.VIEW_ALL_INQUIRIES,
        element: <ViewAllInquiries />
    },
    OUR_PRODUCTS: {
        ...publicRoutePaths.OUR_PRODUCTS,
        element: <OurProducts />
    },
    PRIVACY_POLICY: {
        ...publicRoutePaths.PRIVACY_POLICY,
        element: <PrivacyPolicy />
    },
    BLOG_LIST: {
        ...publicRoutePaths.BLOG_LIST,
        element: <BlogList />
    },
    BLOG_DETAIL: {
        ...publicRoutePaths.BLOG_DETAIL,
        element: <BlogDetail />
    },
    MARKET_PLACE: {
        ...publicRoutePaths.MARKET_PLACE,
        element: <MarketPlace />
    },
    PRODUCT_CATALOGUE: {
        ...publicRoutePaths.PRODUCT_CATALOGUE,
        element: <ProductCatalogue />
    },
    MARKET_DETAIL: {
        ...publicRoutePaths.MARKET_DETAIL,
        element: <MarketDetail />
    },
    COMPANY_CATALOGUE: {
        ...publicRoutePaths.COMPANY_CATALOGUE,
        element: <LandingPage masking={false} />
    },
    OUR_PARTNERS_DETAIL: {
        ...publicRoutePaths.OUR_PARTNERS_DETAIL,
        element: <OurPartnersDetail />
    },
    SEARCH_SUPPLIERS: {
        ...publicRoutePaths.SEARCH_SUPPLIERS,
        element: <SearchSuppliers />
    }

    /** Not in used currently 2025-29-02 */
    /* PARTNER_PAGE: {
        path: "/partner/:id",
        element: <LandingPage masking={true} />
    }*/
};

export {
    publicRoutes
};
